export default {
  title: {
    id: 'insurance_policy_details_payment_details_title',
    defaultMessage: 'Payment details',
  },
  nextPayment: {
    id: 'insurance_policy_details_payment_details_next_payment',
    defaultMessage: 'Next payment',
  },
  nextPaymentDate: {
    id: 'insurance_policy_details_payment_details_next_payment_date',
    defaultMessage: 'on {date}',
  },
  totalDue: {
    id: 'insurance_policy_details_payment_details_total_due',
    defaultMessage: 'Total due today',
  },
  paymentFailedInfoTitle: {
    id: 'insurance_policy_details_payment_details_payment_failed_info',
    defaultMessage:
      'The last few payments haven’t gone through so you’re not currently covered.',
  },
  paymentFailedInfoContent: {
    id: 'insurance_policy_details_payment_details_payment_failed_info_content',
    defaultMessage:
      'To stay protected, catch up on missed payments. Then, you’ll continue to be charged the monthly amount as usual.',
  },
  failedPaymentDuringAttemptPeriodInfoTitle: {
    id: 'insurance_policy_details_payment_details_failed_payment_during_attempt_period_info_title',
    defaultMessage:
      'Your most recent payment didn’t go through. You’re still covered for 14 days after the missed payment.',
  },
  failedPaymentDuringAttemptPeriodInfoContent: {
    id: 'insurance_policy_details_payment_details_failed_payment_during_attempt_period_info_content',
    defaultMessage:
      'Stay protected by catching up on the missed payment. Then, you’ll continue to be charged the monthly amount as usual.',
  },
  updatePaymentMethod: {
    id: 'insurance_policy_details_payment_details_update_payment_method',
    defaultMessage: 'Update payment method',
  },
  updatePaymentMethodButton: {
    id: 'insurance_policy_details_payment_details_update_payment_method_button',
    defaultMessage: 'Update payment method',
  },
  catchUpPaymentButton: {
    id: 'insurance_policy_details_payment_details_catch_up_payment_button',
    defaultMessage: 'Catch up on payments',
  },
}
